import { render, staticRenderFns } from "./FeaturesSlideContent.vue?vue&type=template&id=223e2c17&scoped=true&"
import script from "./FeaturesSlideContent.vue?vue&type=script&lang=js&"
export * from "./FeaturesSlideContent.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesSlideContent.vue?vue&type=style&index=0&id=223e2c17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223e2c17",
  null
  
)

export default component.exports